import { createEntityAdapter } from '@reduxjs/toolkit';

const deliveryTypesAdapter = createEntityAdapter();

export default deliveryTypesAdapter;
